import { render, staticRenderFns } from "./SupplierApplication.vue?vue&type=template&id=28ded5a6&"
import script from "./SupplierApplication.vue?vue&type=script&lang=js&"
export * from "./SupplierApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports